/** Shown in the thread when a user Voice turn cannot be transcribed. */
export const VOICE_TRANSCRIPTION_UNAVAILABLE_TEXT = 'transcription unavailable';

const LEGACY_VOICE_TRANSCRIPTION_UNAVAILABLE_TEXT = '[transcription unavailable]';

export function isVoiceTranscriptionUnavailableText(text: string): boolean {
  return (
    text === VOICE_TRANSCRIPTION_UNAVAILABLE_TEXT || text === LEGACY_VOICE_TRANSCRIPTION_UNAVAILABLE_TEXT
  );
}
